import { render, staticRenderFns } from "./CardRole.vue?vue&type=template&id=73064bfb&"
import script from "./CardRole.vue?vue&type=script&lang=js&"
export * from "./CardRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports